export default __webpack_public_path__ + "338f5c0caf920ac413f3221b53ec76a2.png";